import React, { useContext } from 'react';

import { app } from '../context';

const Label = props => (
  <label className="col-4 col-form-label text-right" {...props} />
);

const Input = ({ value = 0, ...props }) => (
  <input
    className="form-control bg-dark text-light"
    onFocus={e => e.target.select()}
    value={value.toLocaleString()}
    {...props}
  />
);

export default () => {
  const {
    collect,
    onChangeCollect,
    target,
    onChangeTarget,
    walkTime,
    onChangeWalkTime,
    doubled,
    onChangeDoubled,
  } = useContext(app);

  return (
    <div>
      <div className="row my-2">
        <Label>木石採集数</Label>
        <div className="col">
          <Input value={collect} onChange={onChangeCollect} />
        </div>
      </div>
      <div className="row my-3">
        <Label />
        <div className="col">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={doubled}
              onChange={onChangeDoubled}
              id="doubled"
            />
            <label className="form-check-label" htmlFor="doubled">
              もふもふサンダー
            </label>
          </div>
        </div>
      </div>
      <div className="row my-2">
        <Label>目標神器数</Label>
        <div className="col">
          <Input value={target} onChange={onChangeTarget} />
        </div>
      </div>
      <div className="row my-2">
        <Label>必要時間</Label>
        <div className="col input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">每回</span>
          </div>
          <Input value={walkTime} onChange={onChangeWalkTime} />
          <div className="input-group-append">
            <span className="input-group-text">秒</span>
          </div>
        </div>
      </div>
      <div className="row my-2">
        <Label />
        <div className="col">
          <small className="text-secondary">
            ※必要時間：ご都合の移動時間を入力してください
            <br />
            ※サンタの遺産、トナカイの遺産、ぶみぶみダンス、田中のパンツ、ヒモパンのヒモ、もふもふサンダーを持ってる上で使うように
            <br />
            ※木石しか適用できないツールです
            <br />
            ※パダジャは対象外
          </small>
        </div>
      </div>
    </div>
  );
};
